import script from "./VendorMessageDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VendorMessageDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./VendorMessageDetailPage.vue?vue&type=style&index=0&id=5b747c7f&lang=scss"

const __exports__ = script;

export default __exports__